import { Chip } from "@mui/material"
export const COLUMNSPROYECTOS = [
    {
        accessorKey: "id",
    },
    {
        header: "Título",
        accessorKey: "new_name",
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },
    {
        header: "Fecha de inicio",
        accessorKey: "new_fechadeinicio",
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },
    {
        header: "Fecha de finalizacion",
        accessorKey: "new_fechadefinalizacin",
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },
    {
        header: "Institución",
        accessorKey: "_new_institucion_value",
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },
    {
        header: "Institución evaluadora",
        accessorKey: "_new_institucionevaluadora_value",
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },
    {
        header: "Institución financiadora",
        accessorKey: "_new_institucionfinanciadora_value",
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },
    {
        header: "Carácter de la participación",
        accessorKey: "new_carcterdelaparticipcin",
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },
]

export const COLUMNSREVISTAS = [
    {
        accessorKey: "id",
    },
    {
        header: "Con arbitraje?",
        accessorKey: "new_conarbitraje",
        // Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
        Cell: ({ cell }) => {
            switch (cell.getValue()) {
                case "Sí":
                    return <Chip label="Si" sx={{ fontWeight: "bold" }} color="success" variant="outlined" />
                case "No":
                    return <Chip label="No" sx={{ fontWeight: "bold" }} color="error" variant="outlined" />
            }
        },
    },
    {
        header: "Autores",
        accessorKey: "new_autores",
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },
    {
        header: "Título",
        accessorKey: "new_name",
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },
    {
        header: "Revista",
        accessorKey: "new_revista",
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },
    {
        header: "Fecha de publicación",
        accessorKey: "new_fechadepublicacin",
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },
    {
        header: "Volumen",
        accessorKey: "new_volumen",
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },
    {
        header: "Páginas",
        accessorKey: "new_paginas",
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },
]

export const COLUMNSPRESENTACION = [
    {
        accessorKey: "id",
    },
    {
        header: "Autores",
        accessorKey: "new_autores",
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },
    {
        header: "Título",
        accessorKey: "new_name",
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },
    {
        header: "Evento",
        accessorKey: "new_evento",
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },
    {
        header: "Lugar de Realización",
        accessorKey: "new_lugarderealizacin",
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },
    {
        header: "Fecha de Realización",
        accessorKey: "new_fechaderealizacin",
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },
]

export const COLUMNSTITULOS = [
    {
        accessorKey: "id",
    },
    {
        header: "Tipo, desarrollo o producto",
        accessorKey: "new_name",
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },
    {
        header: "Titular",
        accessorKey: "new_titular",
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },
    {
        header: "Fecha de solicitud",
        accessorKey: "new_fechasolicitud",
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },
    {
        header: "Fecha de otorgamiento",
        accessorKey: "new_fechaotorgamiento",
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },
]

export const COLUMNSDESARROLLOS = [
    {
        accessorKey: "id",
    },
    {
        header: "producto",
        accessorKey: "new_name",
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },
    {
        header: "Descripción",
        accessorKey: "new_descripcion",
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },
]